/**
 * @generated SignedSource<<d31b79d10b3bd5558b2a67e4f49bafdc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type CompetitionStageSelectFragment$data = {
  readonly currentStage: {
    readonly id: string;
    readonly seq: number;
  };
  readonly id: string;
  readonly stages: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly seq: number;
        readonly validUntil: DateTime | null | undefined;
      };
    }>;
  };
  readonly " $fragmentType": "CompetitionStageSelectFragment";
};
export type CompetitionStageSelectFragment$key = {
  readonly " $data"?: CompetitionStageSelectFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionStageSelectFragment">;
};

import CompetitionStageSelectFragmentPaginationQuery_graphql from './CompetitionStageSelectFragmentPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "stages"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "seq",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "hasLeaderboard"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "requiresApproval"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompetitionStageSelectFragmentPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CompetitionStageSelectFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CompetitionStage",
      "kind": "LinkedField",
      "name": "currentStage",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        (v2/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": "stages",
      "args": [
        {
          "kind": "Variable",
          "name": "hasLeaderboard",
          "variableName": "hasLeaderboard"
        },
        {
          "kind": "Variable",
          "name": "requiresApproval",
          "variableName": "requiresApproval"
        }
      ],
      "concreteType": "CompetitionStageConnection",
      "kind": "LinkedField",
      "name": "__CompetitionStageSelectFragment_stages_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionStageEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompetitionStage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "validUntil",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*:: as any*/)
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "07372289663f6cdb83cd3d83dd9a7b06";

export default node;
